$(document).ready(function() {
    $.ajax({
        url: 'https://php.shopcode.cz/api/vykrajovatka/api-udalosti.php',
        method: 'GET',
        dataType: 'json',
        success: function(data) {
             data.forEach(item => {
            if (item["datum"]) {
                // odstraní všechny mezery (včetně mezi dnem, měsícem a rokem)
                item["datum"] = item["datum"].replace(/\s+/g, '').trim();

                // pro jistotu ošetří i varianty s chybějící tečkou (např. 6.12.2025)
                const match = item["datum"].match(/^(\d{1,2})\.(\d{1,2})\.?(\d{4})$/);
                if (match) {
                    item["datum"] = `${parseInt(match[1])}.${parseInt(match[2])}.${match[3]}`;
                }
            }
        });
            initializeCalendar(data);
        },
        error: function() {
            console.error('Chyba při načítání dat z API');
        }
    });
});

const monthNames = ["Leden", "Únor", "Březen", "Duben", "Květen", "Červen", "Červenec", "Srpen", "Září", "Říjen", "Listopad", "Prosinec"];
const dayNames = ["Po", "Út", "St", "Čt", "Pá", "So", "Ne"];

function initializeCalendar(data) {
    var currentMonth = new Date().getMonth();
    var currentYear = new Date().getFullYear();
    renderCalendar(currentMonth, currentYear, data);

    $('html').on('click', '#calendar .prev-month', function() {
        currentMonth = (currentMonth - 1 + 12) % 12;
        if (currentMonth === 11) currentYear -= 1;
        renderCalendar(currentMonth, currentYear, data);
    });

    $('html').on('click', '#calendar .next-month', function() {
        currentMonth = (currentMonth + 1) % 12;
        if (currentMonth === 0) currentYear += 1;
        renderCalendar(currentMonth, currentYear, data);
    });

    // Klik na den s akcí
    $(document).on('click', '#calendar .day.has-event', function() {
        var date = $(this).data('date');
        var events = data.filter(item => item["datum"] === date);

        var popupContent = events.map(event => {
            let actionLinkHtml = "";
            if (event["odkaz_na_akci"]) {
                actionLinkHtml = `<div class="actionLink"><a href="${event["odkaz_na_akci"]}" target="_blank">Více informací o akci</a></div>`;
            }

            return `
                <div class="title">${event["nazev_akce"]} <span class="closePoint"></span></div>
                <div class="upper">
 <div class="yearLine"><p>${event["datum"]}</p></div> 
                                ${event["cas"] ? `<div class="time"><p>${event["cas"]}</p></div>` : ''}
                ${event["adresa"] ? `<div class="adress"><p>${event["adresa"]}</p></div>` : ''}

                </div>
                <div class="bottom">
                ${actionLinkHtml}
                <div class="googleCalendar"><span>Přidat do kalendáře</span></div>
                </div>
                `;
        });

        $('#popup').html(popupContent).addClass('open');
        $('#calendar').addClass('openPopup')
    });

    // Zavření popupu při kliknutí mimo
$(document).on('click', function(event) {
    if (!$(event.target).closest('.day.has-event, #popup, .actionCalendar .right ul li small').length) {
        $('#popup').removeClass('open');
        $('#calendar').removeClass('openPopup');
    }
});
    // Zavření popupu při kliknutí na close Button
    $(document).on('click', '.closePoint', function(event) {
            $('#popup').removeClass('open');
            $('#calendar').removeClass('openPopup');
    });

$(document).on('click', '.actionCalendar .right ul li small', function () {
    const eventName = $(this).text().trim();
    const event = data.find(item => item["nazev_akce"].trim() === eventName);
    if (!event) return;

    // 🟢 Zajisti, že #popup existuje (protože renderCalendar() ho vždy přepíše)
    if (!$('#calendar #popup').length) {
        $('#calendar').append('<div id="popup"></div>');
    }

    let actionLinkHtml = "";
    if (event["odkaz_na_akci"]) {
        actionLinkHtml = `<div class="actionLink"><a href="${event["odkaz_na_akci"]}" target="_blank">Více informací o akci</a></div>`;
    }

    const popupContent = `
        <div class="title">${event["nazev_akce"]} <span class="closePoint"></span></div>
        <div class="upper">
            <div class="yearLine"><p>${event["datum"]}</p></div> 
            ${event["cas"] ? `<div class="time"><p>${event["cas"]}</p></div>` : ''}
            ${event["adresa"] ? `<div class="adress"><p>${event["adresa"]}</p></div>` : ''}
        </div>
        <div class="bottom">
            ${actionLinkHtml}
            <div class="googleCalendar"><span>Přidat do kalendáře</span></div>
        </div>
    `;

    // 💥 Nyní popup vždy existuje, takže .addClass funguje
    $('#calendar #popup').html(popupContent).addClass('open');
    $('#calendar').addClass('openPopup');

    // Volitelně posun ke kalendáři
    $('html, body').animate({
        scrollTop: $('#calendar').offset().top - 100
    }, 400);
});




    // Nadcházející akce
    var today = new Date();
    var upcoming = data.filter(event => {
        var parts = event["datum"].split(".");
        var eventDate = new Date(parts[2], parts[1] - 1, parts[0]);
        return eventDate >= today;
    });

    upcoming.sort((a, b) => {
        var aDate = new Date(a["datum"].split(".").reverse().join("-"));
        var bDate = new Date(b["datum"].split(".").reverse().join("-"));
        return aDate - bDate;
    });

    var nextEvents = upcoming.slice(0, 5);
    var html = nextEvents.map(ev => `
        <li>
            <strong>${ev["datum"]}</strong>
            <span>${ev["cas"]}</span>
            <small>${ev["nazev_akce"]}</small>
        </li>
    `).join("");

    $('.actionCalendar .right ul').html(html);
}

function renderCalendar(month, year, data) {
    var daysInMonth = new Date(year, month + 1, 0).getDate();
    var firstDay = new Date(year, month, 1).getDay();
    var firstDayAdjusted = (firstDay === 0 ? 6 : firstDay - 1);
    var daysInPrevMonth = new Date(year, month, 0).getDate();

    var calendarHtml = `
        <div class="month">
            <div class="title">
                <span class="monthYear">${monthNames[month]} ${year}</span>
            </div>
            <div class="buttons">
                <button class="prev-month">Previous</button>
                <button class="next-month">Next</button>
            </div>
        </div>
        <div class="day-names">
    `;

    dayNames.forEach(day => {
        calendarHtml += `<div class="day-name">${day}</div>`;
    });

    calendarHtml += `</div><div class="days">`;

    // Dny předchozího měsíce
    for (var i = firstDayAdjusted; i > 0; i--) {
        var dateStr = `${daysInPrevMonth - i + 1}.${(month === 0 ? 12 : month)}.${(month === 0 ? year - 1 : year)}`;
        var hasEvent = data.some(item => item["datum"] === dateStr);
        calendarHtml += `<div class="day other-month ${hasEvent ? 'has-event' : ''}" data-date="${dateStr}">
                            <div class="inner">${daysInPrevMonth - i + 1}</div>
                        </div>`;
    }

    // Dny aktuálního měsíce
    for (var day = 1; day <= daysInMonth; day++) {
        var dateStr = `${day}.${(month + 1)}.${year}`;
        var hasEvent = data.some(item => item["datum"] === dateStr);
        calendarHtml += `<div class="day ${hasEvent ? 'has-event' : ''}" data-date="${dateStr}">
                            <div class="inner">${day}</div>
                        </div>`;
    }

    // Dny příštího měsíce (aby bylo 6 týdnů)
    var daysInNextMonth = 42 - (firstDayAdjusted + daysInMonth);
    for (var j = 1; j <= daysInNextMonth; j++) {
        var dateStr = `${j}.${(month + 2 === 13 ? 1 : month + 2)}.${(month + 2 === 13 ? year + 1 : year)}`;
        var hasEvent = data.some(item => item["datum"] === dateStr);
        calendarHtml += `<div class="day other-month ${hasEvent ? 'has-event' : ''}" data-date="${dateStr}">
                            <div class="inner">${j}</div>
                        </div>`;
    }

    calendarHtml += '</div><div id="popup"></div>';
    $('.actionCalendar #calendar').html(calendarHtml);

    // Pokud poslední týden obsahuje jen dny z dalšího měsíce, odstraníme ho
    const days = $('#calendar .days .day');
    const lastWeekDays = days.slice(-7);
    const lastWeekContainsOnlyNextMonthDays = lastWeekDays.toArray().every(day => $(day).hasClass('other-month'));

    if (lastWeekContainsOnlyNextMonthDays) {
        lastWeekDays.remove();
    }
}

// Export do Google Kalendáře
$(document).on('click', '.googleCalendar', function(event) {
    event.preventDefault();

    var eventTitle = $(this).closest('#popup').find('.name p').text().trim();
    var eventLocation = $(this).closest('#popup').find('.adress p').text().trim();
    var eventDate = $(this).closest('#popup').find('.yearLine p').text().trim(); // DD.MM.YYYY
    var eventTime = $(this).closest('#popup').find('.time p').text().trim();     // HH:MM - HH:MM

    var dateParts = eventDate.split(".");
    var startDate = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
    var timeParts = eventTime.split("-");
    var startTime = timeParts[0].trim().split(":");
    var endTime = timeParts[1].trim().split(":");

    startDate.setHours(startTime[0], startTime[1]);
    var startDateString = startDate.toISOString().replace(/-|:|\.\d\d\d/g, "");

    var endDate = new Date(startDate);
    endDate.setHours(endTime[0], endTime[1]);
    var endDateString = endDate.toISOString().replace(/-|:|\.\d\d\d/g, "");

    var googleCalendarUrl = "https://www.google.com/calendar/render?action=TEMPLATE" +
        "&text=" + encodeURIComponent(eventTitle) +
        "&dates=" + startDateString + "/" + endDateString +
        "&location=" + encodeURIComponent(eventLocation) +
        "&sf=true&output=xml";

    window.open(googleCalendarUrl, '_blank');
});

// Sdílení na Facebook
$(document).on('click', '.shareFacebook', function(event) {
    event.preventDefault();

    var eventTitle = $(this).closest('#popup').find('.name p').text().trim();
    var eventLocation = $(this).closest('#popup').find('.adress p').text().trim();
    var eventDate = $(this).closest('#popup').find('.yearLine p').text().trim();
    var eventTime = $(this).closest('#popup').find('.time p').text().trim();

    var facebookUrl = "https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(window.location.href) +
        "&quote=" + encodeURIComponent(eventTitle + "\n" + eventLocation + "\n" + eventDate + " " + eventTime);

    window.open(facebookUrl, '_blank');
});
